/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 2906
// module chunks = 0 2